import React from "react";
import "./Anna_Seva.css";
import Common_Title_2 from "../../common/common_components/common_title_2/Common_Title_2";
import White_Btn from "../../common/common_btn/white_btn/White_Btn";
import { useNavigate } from "react-router-dom";

const Anna_Seva = () => {

  const navigate = useNavigate()

  return (
    <section className="Anna_Seva">
      <div className="container">
        <Common_Title_2
          titleText="APPROACH OF GENEROSITY"
          subText="Anna Seva"
        />

        <div className="content_div">
          <div className="vdo_holder">
            <video
              className="vdo"
              src={process.env.PUBLIC_URL + "/assets/videos/anna_seva.mp4"}
              autoPlay
              loop
              muted
              playsInline
            />
          </div>

          <div className="btn_holder">
            <White_Btn btnText={"Donate Now"} onClick={() => { navigate("/donate") }} className="zoom_in_out" />
            {/* <White_Btn btnText={"Donate Now"} onClick={() => { navigate("/annadanam") }} className="zoom_in_out" /> */}
          </div>

        </div>
      </div>
    </section>
  );
};

export default Anna_Seva;
